var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container platform-basic-info-page" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("平台建设")]),
              _c("el-breadcrumb-item", [_vm._v("基础信息")]),
              _c("el-breadcrumb-item", [_vm._v("SLA信息")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("1.服务器故障类工单SLA")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.serverFaultData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { prop: "class", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("工单级别")]),
                    _c("div", [_vm._v("ServerFaultClass")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "responseTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("工单响应与分派(分钟)")]),
                    _c("div", [_vm._v("ServerFailRD_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "arrivalTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("服务人员达到现场")]),
                    _c("div", [_vm._v("ServerFailEA_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "completionTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("操作完成时间")]),
                    _c("div", [_vm._v("ServerFaultOF_SLA")])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [
        _vm._v("2.服务器资源交付类丅单SLA")
      ]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.serverResourceData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { prop: "class", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("工单类型")]),
                    _c("div", [_vm._v("ServerResClass")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "responseTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("工单响应与分派(分钟)")]),
                    _c("div", [_vm._v("ServerResRD_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "arrivalTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("服务人员达到现场")]),
                    _c("div", [_vm._v("ServerResEA_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "completionTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("操作完成时间")]),
                    _c("div", [_vm._v("ServerResOF_SLA")])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("3.网络故障类工单SLA")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.netFaultData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { prop: "class", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("工单级别")]),
                    _c("div", [_vm._v("NetFaultClass")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "responseTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("工单响应与分派(分钟)")]),
                    _c("div", [_vm._v("NetFaultRD_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "arrivalTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("服务人员达到现场")]),
                    _c("div", [_vm._v("NetFaultEA_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "completionTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("操作完成时间")]),
                    _c("div", [_vm._v("NetFaultOP_SLA")])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("4.网络其它工单SLA")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.netOthersData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { prop: "class", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("工单类型")]),
                    _c("div", [_vm._v("NetOthersClass2")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "responseTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("工单响应与分派")]),
                    _c("div", [_vm._v("NetOters2RD_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "arrivalTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("服务人员达到现场")]),
                    _c("div", [_vm._v("NetOters2EA_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "completionTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("操作完成时间")]),
                    _c("div", [_vm._v("NetOters2OF_SLA")])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("5.资产操作类工单SLA")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.assetOperationData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { prop: "class", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("资产操作类")]),
                    _c("div", [_vm._v("AssetStoreClass")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "responseTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("工单响应与分派(分钟)")]),
                    _c("div", [_vm._v("AssetStoreRD_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "arrivalTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("服务人员达到现场")]),
                    _c("div", [_vm._v("AssetStoreEA_SLA")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "completionTime", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("操作完成时间")]),
                    _c("div", [_vm._v("AssetStoreOF_SLA")])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }